export default (path, oldParam, newParam) => {
  const pathElementArr = path.split('/')
  const index = pathElementArr.findIndex((el) => el === oldParam)
  if (index !== -1) {
    const newPathElementArr = pathElementArr.slice(0, index - 1)
    return `${newPathElementArr.join('/')}/${newParam}`
  }
  return `${path}/${newParam}`
}
